import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./index.css";
import { useAnimatedStockBanner } from "./useAnimatedStockBanner";
import getStockStatusAriaLabel from "./getStockStatusAriaLabel";
import getStockStatus from "./getStockStatus";

const ProductStockBanner = ({ labelledById, className, ...rest }) => {
  const stockStatus = getStockStatus({ ...rest });
  const {
    isRendered,
    onTransitionEnd,
    style: statusStyle,
    content
  } = useAnimatedStockBanner({ stockStatus });

  if (!isRendered) return null;

  return (
    <div
      className={classnames(className, styles.banner, statusStyle)}
      onTransitionEnd={onTransitionEnd}
      id={labelledById}
      aria-label={getStockStatusAriaLabel(stockStatus)}
      aria-hidden={true}
      role="status"
    >
      {content}
    </div>
  );
};

ProductStockBanner.propTypes = {
  labelledById: PropTypes.string.isRequired,
  variantId: PropTypes.number,
  className: PropTypes.string
};

export default ProductStockBanner;
